// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Img_fadeIn__Rwsyj","container":"Img_container__l3BCT","image":"Img_image__JSV5e"};